var $bc78ecf2de5c1277$exports = {};
$bc78ecf2de5c1277$exports = {
  "backButton": args => "".concat(args.prevMenuButton, " \u306B\u623B\u308B"),
  "moreActions": "\u305D\u306E\u4ED6\u306E\u30A2\u30AF\u30B7\u30E7\u30F3",
  "unavailable": "\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002\u8A73\u3057\u304F\u306F\u3001\u5C55\u958B\u3057\u3066\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044"
};
export { $bc78ecf2de5c1277$exports as default };